<template>
  <div>
    <v-container fluid class="my-0 py-0">
      <v-card class="mx-0 px-0 mt-3" :elevation="8">
        <ProduzioneLayout
          style="padding: 0px"
          :commessa="{}"
          :rotta_back="rotta_back"
          :work_order_sempre_aperto="work_order_sempre_aperto"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import ProduzioneLayout from "@/views/PRODUCTION/ProduzioneLayout/ProduzioneLayout.vue";

export default {
  name: "EMProduzioneLayoutAdapter",
  props: [],
  components: {
    ProduzioneLayout,
  },
  data() {
    return {
      // Variabili d'appoggio
      rotta_back: "/home/production",
      work_order_sempre_aperto: false,
      // Modal

      // Array
    };
  },
  watch: {},
  methods: {
    getModuliAlternativi() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "AVANZAMENTO",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni sulla chiusura automatica fase, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "CHIUSURA_AUTOMATICA_FASE"
              ).length > 0
            ) {
              this.work_order_sempre_aperto =
                res.data.result.filter(
                  (e) => e.descrizione === "COMMESSA_EXTRA"
                )[0].val_int == 0
                  ? false
                  : true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
  },
  mounted() {
    this.getModuliAlternativi();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>